import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/AddCityHQ.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
const AddCityHQ = () => {
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [cityName, setCityName] = useState("");
  
    // ✅ Fetch states from API
    useEffect(() => {
      // For GET requests
        axios.get(`${BASE_URL}/api/states`, {
          headers: getAuthHeaders()
        })
        .then((res) => setStates(res.data))
        .catch((err) => console.error("Error fetching states:", err));
    }, []);
  
    const handleSubmit = (e) => {
        e.preventDefault();
      
        if (!selectedState || !cityName) {
          alert("Please select a state and enter a city name.");
          return;
        }
      
        const stateObj = states.find((state) => state.name === selectedState);
        if (!stateObj) {
          alert("Invalid state selection.");
          return;
        }
      
        const payload = {
          name: cityName,     // ✅ Only sending required fields
          state_id: stateObj.id,
        };
      
        console.log("Sending payload:", payload); // ✅ Debugging
      
       // For POST requests
        axios.post(`${BASE_URL}/api/cities`, payload, {
          headers: getAuthHeaders()
        })
          .then(() => {
            alert("City added successfully!");
            navigate(-1);
          })
          .catch((err) => {
            console.error("Error adding city:", err.response ? err.response.data : err);
          });
      };
  
    return (
      <div className="master-container">
      
      {/* <div className="add-title-container">
        <h3 className="page-title">Add, View and Edit City</h3> */}
        <div className="add-city-container">
        <div className="section-title-container">
           <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mt-12 whitespace-nowrap">
        <span className="text-blue-700">ADD </span>
        <span className="text-blue-500">CITY/HQ</span>
      </h1>
          
          </div>
          
          <form className="city-form" onSubmit={handleSubmit}>
            <div className="form-row three-column">
              {/* Country Column */}
              <div className="form-column">
                <label className="form-label">COUNTRY</label>
                <select className="form-input" disabled>
                  <option value="India">India</option>
                </select>
              </div>
  
              {/* State Column */}
              <div className="form-column">
                <label className="form-label">STATE NAME *</label>
                <select 
                  className="form-input" 
                  value={selectedState} 
                  onChange={(e) => setSelectedState(e.target.value)}
                >
                  <option value="">Select</option>
                  {states.map((state) => (
                    <option key={state.id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
  
              {/* City/HQ Column */}
              <div className="form-column">
                <label className="form-label">CITY/HQ NAME *</label>
                <input 
                  type="text" 
                  className="form-input" 
                  value={cityName} 
                  onChange={(e) => setCityName(e.target.value)} 
                />
              </div>
            </div>
  
            {/* Buttons positioned below the form fields */}
            <div className="button-group">
                <button type="submit" className="btn-submit">
                Submit
              </button>
              <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>
                Cancel
              </button>
            
            </div>
          </form>
        </div>
      <div className="footer-wrapper"> {/* New footer wrapper */}
    </div>
    </div>
    );
  };
  
  export default AddCityHQ;